export { default } from './CamTimeout';
